import { Link } from 'react-router-dom';
import type { ToolItem } from '../data/tools';
import { getIconComponent } from '../lib/icons';
import clsx from 'clsx';

interface ToolCardProps {
  tool: ToolItem;
  className?: string;
}

/**
 * 首頁工具卡片：圖示、名稱、簡介，點擊導向 /tools/:slug
 */
export function ToolCard({ tool, className }: ToolCardProps) {
  const Icon = getIconComponent(tool.icon);

  return (
    <Link
      to={`/tools/${tool.slug}`}
      className={clsx(
        'group flex flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-300 hover:shadow-[0_14px_34px_rgba(15,23,42,0.10)] dark:border-gray-700 dark:bg-gray-800/90 dark:hover:border-gray-600',
        className
      )}
    >
      <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl border border-gray-200 bg-gradient-to-br from-white to-gray-100 text-primary transition group-hover:border-primary/30 group-hover:from-primary/5 group-hover:to-violet-100 dark:border-gray-600 dark:from-gray-800 dark:to-gray-700 dark:group-hover:to-violet-950/40">
        {Icon ? <Icon className="h-6 w-6" /> : null}
      </div>
      <h3 className="text-base font-semibold tracking-tight text-gray-900 dark:text-gray-100">
        {tool.name}
      </h3>
      <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
        {tool.description}
      </p>
    </Link>
  );
}
